import { render, staticRenderFns } from "./UserPayer.vue?vue&type=template&id=386ed86d&scoped=true"
import script from "./UserPayer.vue?vue&type=script&lang=js"
export * from "./UserPayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386ed86d",
  null
  
)

export default component.exports